import { Action } from '@interstate/components/Action';
import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';

import { DEALER_SUPPORT_REQUEST_FORM } from '../constants';

const openSupportTicketUrl = () => {
    window.open(DEALER_SUPPORT_REQUEST_FORM);
};
export const ServiceUnavailableAlert = () => (
    <Alert type="error" role="alert" title="Service Unavailable" data-testid="search-error-alert">
        <Typography variant="body-sm" tag="span">
            Please contact support: 1-888-895-2994 or create a&nbsp;
        </Typography>
        <Action onClick={openSupportTicketUrl} data-testid="support-ticket">
            <Typography variant="anchor-inline-sm" tag="a" color="sem.color.surface.button.primary.rest">
                support ticket
            </Typography>
        </Action>
    </Alert>
);
